<ul class="nav nav-pills mb-3">
  <ng-container *ngFor="let route of items">
    <li class="nav-item" *ngIf="route.path && permissionService.get(route.data?.permission)">
      <a class="nav-link" [routerLink]="route.path" routerLinkActive="active">{{ route.data?.title }}</a>
    </li>
  </ng-container>
</ul>
